function fn_part_ui_heading(){
    $("[data-heading-clip]").each(function(index){
        var $this = $(this).find("i");
        var $points = [[0, 7.35], [100, 0], [97, 100], [2.5, 100], [0, 7.35]];

        $this.clipPath($points, {
            isPercentage: true,
            svgDefId: "headingclip"+index
        })
    })
}